import React, { ReactNode } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

export interface ConfirmDialogProps {
  title: string;
  children: ReactNode;
  open: boolean;
  confirmText: string;
  cancelText?: string;
  setOpen: (open: boolean) => void;
  onConfirm: () => void; 
};

const ConfirmDialog = (props: ConfirmDialogProps) => {
  return (
    <Dialog
      open={props.open}
      onClose={() => props.setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{props.title}</DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        {props.cancelText ? (
          <Button
            variant="contained"
            onClick={() => props.setOpen(false)}
            color="secondary"
          >
            {props.cancelText}
          </Button>
        ) : null}
        <Button
          variant="contained"
          onClick={() => {
            props.setOpen(false);
            props.onConfirm();
          }}
          color="default"
        >
          {props.confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;